export default {
  aquadata: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: false,
      remindByEmail: {
        show: false,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    }
  },
  bell: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: false,
      remindByEmail: {
        show: false,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: false
    }
  },
  boisbriand: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: false,
      remindByEmail: {
        show: false,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: true
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: false
    }
  },
  brossard: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: true
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
        defaultValue: true,
      },
      publishProjectPhase: {
        show: true,
        defaultValue: true,
      },
      publishProjectWorkNotice: {
        show : true,
        defaultValue: true,
      },
      publishProjectToWaze: {
        show: true,
        defaultValue: true,
      }
    },
    ssoLoginEsri:{
      show: false
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true 
    },
    showGpsPositionButton:{
      show:true
    },
    searchSource:{
      isQuebec: false,
      isDefaultESRI: false,
      isDefaultCenterline: true,
    },
    quickCreateProject:{
      show: true
    },
    copyProject:{
      show: true
    },
    stakeholderAutocomplete:{
      show:true
    },
  },
  can: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: false
    }
  },
  canada: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: false
    }
  },
  gatineau: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: true,
      internalCommunication: {
        show: true
      },
      citizenOpinions: {
        show: true
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: true
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: true
    },
    exportProjectButtonOnProjectListingHeader: {
      show: true,
      exportCsv : {
        show: true
      },
      exportXls : {
        show : true
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      defaultValue : true,
      publishToCitizen: {
        show: true,
        defaultValue: true,
      },
      publishProjectPhase: {
        show: true,
        defaultValue: true,
      },
      publishProjectWorkNotice: {
        show : true,
        defaultValue: true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: false
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    quickCreateProject:{
      show: true
    },
    stakeholderAutocomplete:{
      show:true
    },
    searchSource:{
      isQuebec: true,
      isDefaultESRI: false,
      isDefaultCenterline: false,
    },
    autoSave:{
      show:true
    },
    helpOnSidebar:{
      show: true
    },
    copyProject:{
      show: true
    }
  },
  gis: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: true,
      exportCsv : {
        show: true
      },
      exportXls : {
        show : true
      },
      exportGeojson : {
        show : true
      }
    },
    exportProjectButtonInProjectListing: {
      show: true
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: true,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    searchSource:{
      isQuebec: true,
      isDefaultESRI: true,
      isDefaultCenterline: true,
    },
    featureLayerOnEntrave:{
      show: true
    }
  },
  hampstead: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: false
    },
    searchSource:{
      isQuebec: false,
      isDefaultESRI: false,
      isDefaultCenterline: true,
    }
  },
  montroyal: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: true,
      internalCommunication: {
        show: true
      },
      citizenOpinions: {
        show: true
      },
      externalCommunication: {
        show: true
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: true
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: false
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    searchSource:{
      isQuebec: false,
      isDefaultESRI: false,
      isDefaultCenterline: true,
    },
    quickCreateProject:{
      show: true
    },
    copyProject:{
      show: true
    },
    showPermits:{
      show: true,
    }
  },
  quebec: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: true
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    userLoginDisable:{
      show: false
    },
    ssoLoginMicrosoft:{
      show: true
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    searchSource:{
      isQuebec: true,
      isDefaultESRI: false,
      isDefaultCenterline: false,
    },
    quickCreateProject:{
      show: true
    },
    copyProject:{
      show: true
    },
    autoSave:{
      show:true
    },
    helpOnSidebar:{
      show: true
    },
  },
  toronto: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: false,
      remindByEmail: {
        show: false,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: false
    }
  },
  repentigny: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: true
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: false
    }
  },
  roadworks: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: true,
      exportCsv : {
        show: true
      },
      exportXls : {
        show : true
      },
      exportGeojson : {
        show : true
      }
    },
    exportProjectButtonInProjectListing: {
      show: true
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: true,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: true
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    searchSource:{
      isQuebec: false,
      isDefaultESRI: true,
      isDefaultCenterline: false,
    },
    featureLayerOnEntrave:{
      show: true
    },
    isCustomSidebar:{
      conflictPage: true,
      publicMapPage: true,
      timelinePage: true,
      userManagement: true,
    },
    isCustomIcon:{
      show:true,
      timeline: true,
      project: true,
    },
    quickCreateProject:{
      show: true
    },
    copyProject:{
      show: true
    }
  },
  safelane: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: true,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: true
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: true,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    featureLayerOnEntrave:{
      show: true
    }
  },
  sjsr: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: true
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    userLoginDisable:{
      show: false
    },
    ssoLoginMicrosoft:{
      show: true
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    searchSource:{
      isQuebec: true,
      isDefaultESRI: false,
      isDefaultCenterline: false,
    },
    quickCreateProject:{
      show: true
    },
    copyProject:{
      show: true
    },
    autoSave:{
      show:true
    },
    helpOnSidebar:{
      show: true
    },
  },
  toronto: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: false,
      remindByEmail: {
        show: false,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: false
    }
  },
  us: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: false,
      remindByEmail: {
        show: false,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    }
  },
  vancouver: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: false,
      remindByEmail: {
        show: false,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: false
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: false
    }
  },
  cigo: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: true,
      exportCsv : {
        show: true
      },
      exportXls : {
        show : true
      },
      exportGeojson : {
        show : true
      }
    },
    exportProjectButtonInProjectListing: {
      show: true
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: true,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    }
  },
  mississauga: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: true
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: true,
      exportCsv : {
        show: true
      },
      exportXls : {
        show : true
      },
      exportGeojson : {
        show : true
      }
    },
    exportProjectButtonInProjectListing: {
      show: true
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: true,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: true
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    quickCreateProject:{
      show: true
    },
    searchSource:{
      isQuebec: false,
      isDefaultESRI: true,
      isDefaultCenterline: false,
    },
    isCustomSidebar:{
      conflictPage: true,
      publicMapPage: true,
      timelinePage: true,
      userManagement: true,
    },
    isCustomIcon:{
      show:true,
      timeline: true,
      project: true,
    }
  },
  admtl: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: false
    },
    searchSource:{
      isQuebec: true,
      isDefaultESRI: false,
      isDefaultCenterline: false,
    },
    polygonProject:{
      show:true
    },
    autoSave:{
      show:true
    },
    isCustomIcon:{
      show:false,
      timeline: false,
      project: false,
    },
  },
  opa24: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: true,
      internalCommunication: {
        show: true
      },
      citizenOpinions: {
        show: true
      },
      externalCommunication: {
        show: true
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: false
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: true
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: false
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    searchSource:{
      isQuebec: false,
      isDefaultESRI: false,
      isDefaultCenterline: true,
    }
  },
  magog: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: true
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    ssoLoginMicrosoft:{
      show: true
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    searchSource:{
      isQuebec: true,
      isDefaultESRI: false,
      isDefaultCenterline: false,
    },
    quickCreateProject:{
      show: false
    },
    copyProject:{
      show: true
    },
    autoSave:{
      show:true
    },
    helpOnSidebar:{
      show: true
    },
    polygonProject:{
      show: true
    },
    addressLayerInReportProject:{
      show: true
    },
    isCustomIcon:{
      show:true,
      timeline: true,
      project: true,
    },
    timeRange:{
      show: true,
    },
    customEntityFilter:{
      show: true,
    },
    featureLayerOnEntrave:{
      show: true
    }
  },
  vd: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: true
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: false
    },
    ssoLoginMicrosoft:{
      show: false
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    searchSource:{
      isQuebec: true,
      isDefaultESRI: false,
      isDefaultCenterline: false,
    },
    quickCreateProject:{
      show: true
    },
    copyProject:{
      show: true
    },
    autoSave:{
      show:true
    },
    helpOnSidebar:{
      show: false
    },
    polygonProject:{
      show: true
    },
    isCustomIcon:{
      show:true,
      timeline: true,
      project: true,
    },
    timeRange:{
      show: false,
    },
    timeOfDay:{
      show: true,
    },
    customEntityFilter:{
      show: false,
    },
    featureLayerOnEntrave:{
      show: true
    },
    stakeholderAutocomplete:{
      show:true
    },
    mapColorBy: {
      show: true,
      mode: 'step',
      colors: { '4': '#9E9E9E', '1': '#FFE600', '2': '#FF6A00', '7': '#5BC8F5', '8': '#6A0DAD', '9': '#00C800', '3': '#8B4513' }
    },
    showPermits:{
      show: true,
    },
    showDcm:{
      show: true,
    },
    emailCc:{
      show: true,
    },
  },
  guelph: {
    publicContactInStakeholders: {
      show: true
    },
    copyNotesToComments: {
      show: true
    },
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: true
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: false
    },
    ssoLoginMicrosoft:{
      show: true
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    searchSource:{
      isQuebec: false,
      isDefaultESRI: true,
      isDefaultCenterline: false,
    },
    quickCreateProject:{
      show: true
    },
    copyProject:{
      show: true
    },
    autoSave:{
      show:true
    },
    helpOnSidebar:{
      show: true
    },
    polygonProject:{
      show: false
    },
    isCustomIcon:{
      show:true,
      timeline: true,
      project: true,
    },
    timeRange:{
      show: false,
    },
    customEntityFilter:{
      show: false,
    },
    featureLayerOnEntrave:{
      show: true
    },
    defaultLanguage:{
      show: true,
      value: 'en'
    },
    stakeholderAutocomplete:{
      show:true
    },
    embedIframeOnPublicPage:{
      show: true
    },
    downloadHtmlReport:{
      show: true
    },
    noticeEmailBody: {
      show: true
    },
    mapColorBy: {
      show: true,
      mode: 'impact',
      colors: { '1': '#FFE600' },
      impact: { '1': '#E3000F', '2': '#FF8C00', '3': '#FF8C00', '4': '#FF8C00', '5': '#FF8C00', '6': '#9E9E9E' },
      impactDefault: '#FF8C00',
      detour: '#00A651'
    },
    roadworksLogo: {
      show: true
    },
  },
  mascouche: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: true
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    noticeIncludeAgent: {
      show: true
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    userLoginDisable:{
      show: false
    },
    ssoLoginMicrosoft:{
      show: true
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    searchSource:{
      isQuebec: true,
      isDefaultESRI: false,
      isDefaultCenterline: false,
    },
    quickCreateProject:{
      show: true
    },
    copyProject:{
      show: true
    },
    autoSave:{
      show:true
    },
    helpOnSidebar:{
      show: true
    },
  },
  vsj: {
    communicationToolsOnProjectInformationPageWhileAddingOrUpdating: {
      show: false,
      internalCommunication: {
        show: false
      },
      citizenOpinions: {
        show: false
      },
      externalCommunication: {
        show: false
      }
    },
    dropDownNoticeTypeInReportProjectModalOnProjectListiing: {
      show: true
    },
    dropDownClosuresInReportProjectModalOnProjectListiing: {
      show: false
    },
    exportProjectButtonOnProjectListingHeader: {
      show: false,
      exportCsv : {
        show: false
      },
      exportXls : {
        show : false
      },
      exportGeojson : {
        show : false
      }
    },
    exportProjectButtonInProjectListing: {
      show: false
    },
    projectReminderButtonInProjectListing: {
      show: true,
      remindByEmail: {
        show: true,
      },
      remindBySMS: {
        show: false,
      }
    },
    userTypeAdminGISRadioButtonInUserEdit: {
      show: true
    },
    publishProjectToPublicMap: {
      show: true,
      publishToCitizen: {
        show: true,
      },
      publishProjectPhase: {
        show: true,
      },
      publishProjectWorkNotice: {
        show : true,
      },
      publishProjectToWaze: {
        show: true
      }
    },
    ssoLoginEsri:{
      show: true
    },
    userLoginDisable:{
      show: false
    },
    ssoLoginMicrosoft:{
      show: true
    },
    emailLogsOnSidebar:{
      show: true
    },
    feedbackOnSidebar: {
      show: true
    },
    searchSource:{
      isQuebec: true,
      isDefaultESRI: false,
      isDefaultCenterline: false,
    },
    quickCreateProject:{
      show: true
    },
    copyProject:{
      show: true
    },
    autoSave:{
      show:true
    },
    helpOnSidebar:{
      show: true
    },
    isCustomIcon:{
      show:true,
      timeline: true,
      project: true,
    },
    mapColorBy: {
      show: true,
      mode: 'step',
      colors: { '1': '#FFE600', '2': '#FF6A00', '3': '#00C800', '7': '#5BC8F5', '8': '#6A0DAD', '4': '#E00000','5': '#FFE600' }
    },
    noticeWithoutPdf: {
      show: true
    },
    noticeEmailBody: {
      show: true
    },
    infoTravaux: {
      show: true
    },
  },
}
